import { useCallback } from 'react';
import { SITE_ACCESS_QUERY_KEY } from '@hotjar/webapp/features/Core/Nav/components/SiteDropdown/useSiteAccess';
import { USER_RESOURCES_QUERY_KEY } from '@hotjar/user-resources';
import { ORGANIZATIONS_QUERY_KEY } from '@hotjar/organization';
import { queryClient } from '@hotjar/webapp/utils/react-query';
import { bus, refreshData } from '@hotjar/webapp/utils/events';

type UseOrganizationWithInvalidateResponse = () => Promise<void>;

// This hook can only be used in pages started with angular router
// due to limitations with the react router implementation
// Once we finish the react migration, we will be able to merge it in
// the existing useOrganizations hook.
export function useOrganizationsInvalidate(): UseOrganizationWithInvalidateResponse {
  return useCallback(async () => {
    await Promise.all([
      queryClient.invalidateQueries(ORGANIZATIONS_QUERY_KEY),
      // invalidate sites
      queryClient.invalidateQueries(USER_RESOURCES_QUERY_KEY),
      // invalidate the call that happens inside main nav site dropdown
      queryClient.invalidateQueries(SITE_ACCESS_QUERY_KEY),
    ]);
    // this is to refresh data from server for angularjs
    // TODO: future person: if you see this and webapp are migrated to React we can probably remove this
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    bus.publish(refreshData(() => {}));
  }, []);
}
